module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (("-webkit-transform:translate(" + (_vm.value.x) + "px," + (_vm.value.y) + "px);transform:translate(" + (_vm.value.x) + "px, " + (_vm.value.y) + "px);")),
    attrs: {
      "data-x": _vm.value.x,
      "data-y": _vm.value.y
    }
  }, [(_vm.value.type === 'hydraulic') ? _c('md-icon', {
    staticClass: "md-size-05x",
    attrs: {
      "data-key": _vm.number
    }
  }, [_vm._v("opacity")]) : _vm._e(), _vm._v(" "), (_vm.value.type === 'eletric') ? _c('md-icon', {
    staticClass: "md-size-05x",
    attrs: {
      "data-key": _vm.number
    }
  }, [_vm._v("power")]) : _vm._e(), _vm._v(" "), (_vm.value.type === 'equipment') ? _c('md-icon', {
    staticClass: "  md-size-05x",
    attrs: {
      "data-key": _vm.number
    }
  }, [_vm._v("kitchen")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa6d9b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DraggableStructure.vue
// module id = 822
// module chunks = 1